import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss']
})
export class InstagramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
